import i18n from '../../language/index'
import linkData from '@/base/linkData'
import { create_font_set } from './../../base/fontSetData'
import img_effects from '@/base/img_effects'
export default {
  img_effects, //不知道这个是啥 但是去掉会报错
  /* animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation', */
  animation_set: {
    start: 0,
    target: 50,
    end: 100,
    useGrouping: false, // 千分位分组
    decimalPlaces: 0, //小数位 的个数 0 -6
  },
  pc_widgets_infor: {
    ...create_font_set(),
    backgroundStart:{ // 初始颜色
      radio_val: 'default',
      default:{
        type:'color', // 背景设置-类型
        img:'', // 背景设置-图片的URL
        color: 'rgba(222, 222, 222, 1)', // 背景设置-颜色
        img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'auto',
        background_repeat: 'repeat',
        background_position: 'center center' //图片位置
      },
      custom:{
        type:'color', // 背景设置-类型
        img:'', // 背景设置-图片的URL
        color: 'rgba(222, 222, 222, 1)', // 背景设置-颜色
        img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'auto',
        background_repeat: 'repeat',
        background_position: 'center center' //图片位置
      }
    },
    backgroundEnd:{ // 完成颜色
      radio_val: 'default',
      default:{
        type:'color', // 背景设置-类型
        img:'', // 背景设置-图片的URL
        color: 'rgba(32, 151, 243, 1)', // 背景设置-颜色
        img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'auto',
        background_repeat: 'repeat',
        background_position: 'center center' //图片位置
      },
      custom:{
        type:'color', // 背景设置-类型
        img:'', // 背景设置-图片的URL
        color: 'rgba(32, 151, 243, 1)', // 背景设置-颜色
        img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'auto',
        background_repeat: 'repeat',
        background_position: 'center center' //图片位置
      }
    },
    borderRadius:{ // 圆角
      radio_val: 'default',
      default: {
        value: 0,
      },
      custom: {
        value: 0,
      }
    },
    playSet: { // 播放设置
      radio_val: 'default',
      default: {
        duration: 10,
        delay: 0.1
      },
      custom: {
        duration: 10,
        delay: 0.1,
      },

    },
    /* useGrouping: false, // 千分位分组
    decimalPlaces: 0, //小数位 的个数 0 -6 */
   /*  moduleStyle: 'left_right', // 模块样式 // left right bottom top
    direction: 'left' */
    moduleSet: {
      radio_val: 'left_right',
      left_right: {
        direction: 'left'
      },
      bottom_top: {
        direction: 'bottom'
      }
    },
    border: {
      radio_val: 'default',
      default: {
        borderWidth: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        borderTopWidth: 0,
        borderBottomWidth: 0,
        borderStyle: 'solid',
        borderColor: "rgba(255, 255, 255,1)",
        borderSeColor: undefined,
        checkList: ['borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth'],
      },
      custom: {
        borderWidth: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        borderTopWidth: 0,
        borderBottomWidth: 0,
        borderStyle: 'solid',
        borderColor: "rgba(255, 255, 255,1)",
        borderSeColor: undefined,
        checkList: ['borderTopWidth', 'borderLeftWidth'],
      }
    },
    height: 60,//特殊字段，只存在搜索和按钮
    box_paddingLeft:"0%",
    box_paddingRight:"0%",
    box_paddingTop:"0%",
    box_paddingBottom:"0%",
  },
  mb_widgets_infor: {
    ...create_font_set(),
    backgroundStart:{ // 初始颜色
      radio_val: 'default',
      default:{
        type:'color', // 背景设置-类型
        img:'', // 背景设置-图片的URL
        color: 'rgba(222, 222, 222, 1)', // 背景设置-颜色
        img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'auto',
        background_repeat: 'repeat',
        background_position: 'center center' //图片位置
      },
      custom:{
        type:'color', // 背景设置-类型
        img:'', // 背景设置-图片的URL
        color: 'rgba(222, 222, 222, 1)', // 背景设置-颜色
        img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'auto',
        background_repeat: 'repeat',
        background_position: 'center center' //图片位置
      }
    },
    backgroundEnd:{ // 完成颜色
      radio_val: 'default',
      default:{
        type:'color', // 背景设置-类型
        img:'', // 背景设置-图片的URL
        color: 'rgba(32, 151, 243, 1)', // 背景设置-颜色
        img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'auto',
        background_repeat: 'repeat',
        background_position: 'center center' //图片位置
      },
      custom:{
        type:'color', // 背景设置-类型
        img:'', // 背景设置-图片的URL
        color: 'rgba(32, 151, 243, 1)', // 背景设置-颜色
        img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'auto',
        background_repeat: 'repeat',
        background_position: 'center center' //图片位置
      }
    },
    borderRadius:{ // 圆角
      radio_val: 'default',
      default: {
        value: 0,
      },
      custom: {
        value: 0,
      }
    },
    /* playSet: { // 播放设置
      radio_val: 'default',
      default: {
        duration: 10,
        delay: 0.1
      },
      custom: {
        duration: 0,
        delay: 0,
      },

    }, */
    /* useGrouping: false, // 千分位分组
    decimalPlaces: 0, //小数位 的个数 0 -6 */
   /*  moduleStyle: 'left_right', // 模块样式 // left right bottom top
    direction: 'left' */
    /* moduleSet: {
      radio_val: 'left_right',
      left_right: {
        direction: 'left'
      },
      bottom_top: {
        direction: 'bottom'
      }
    }, */
    border: {
      radio_val: 'default',
      default: {
        borderWidth: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        borderTopWidth: 0,
        borderBottomWidth: 0,
        borderStyle: 'solid',
        borderColor: "rgba(255, 255, 255,1)",
        borderSeColor: undefined,
        checkList: ['borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth'],
      },
      custom: {
        borderWidth: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        borderTopWidth: 0,
        borderBottomWidth: 0,
        borderStyle: 'solid',
        borderColor: "rgba(255, 255, 255,1)",
        borderSeColor: undefined,
        checkList: ['borderTopWidth', 'borderLeftWidth'],
      }
    },
    height: 60,//特殊字段，只存在搜索和按钮
    box_paddingLeft:"0%",
    box_paddingRight:"0%",
    box_paddingTop:"0%",
    box_paddingBottom:"0%",
  },
  listArr: {
    title: i18n.t('widgets_basic_progress_style_2802'),
    link: linkData
  },
 /*  pc_infor:{
    marginTop:'0%',
    marginLeft:'40%',
    marginRight:'40%',
    marginBottom:'0%',
    textAlign: 'center'
  },
  mb_infor:{
    marginTop:'2.666%',
    marginLeft:'30%',
    marginRight:'30%',
    marginBottom:'1.333%',
    textAlign: 'center'
  }, */
}



// WEBPACK FOOTER //
// ./src/widgets/basic_progress/style.js